import request from '@/utils/request'

// 新增岗位信息
export function addPosition(data) {
  return request({
    url: '/api/v1/sys/post/add',
    method: 'post',
    data,
    load: true,
    debounce: true,
  })
}

// 删除岗位信息
export function deletePosition(postIds) {
  return request({
    url: '/api/v1/sys/post/del/'+postIds,
    method: 'delete',
    load: true,
    debounce: true,
  })
}

// 修改岗位信息
export function updatePosition(data) {
  return request({
    url: '/api/v1/sys/post/edit',
    method: 'put',
    data,
    load: true,
    debounce: true,
  })
}

// 获取岗位信息详细信息
export function getPosition(postId) {
  return request({
    url: '/api/v1/sys/post/info/'+postId,
    method: 'get',
    load: true
  })
}

// 查询岗位信息列表
export function getPositionList(data) {
  return request({
    url: '/api/v1/sys/post/list',
    method: 'post',
    data,
    load: true
  })
}

// 获取岗位下拉列表
export function getPositionListAll(params) {
  return request({
    url: '/api/v1/sys/post/listAll',
    method: 'get',
    load: true,
    params
  })
}
